export const isBackForward = ()=>{
    try {
        var _window_performance_getEntriesByType_, _window_performance_getEntriesByType, _window_performance, _window;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        return ((_window = window) === null || _window === void 0 ? void 0 : (_window_performance = _window.performance) === null || _window_performance === void 0 ? void 0 : (_window_performance_getEntriesByType = _window_performance.getEntriesByType('navigation')) === null || _window_performance_getEntriesByType === void 0 ? void 0 : (_window_performance_getEntriesByType_ = _window_performance_getEntriesByType[0]) === null || _window_performance_getEntriesByType_ === void 0 ? void 0 : _window_performance_getEntriesByType_.type) === 'back_forward';
    } catch (_) {
        var _window_performance_navigation, _window_performance1, _window1;
        return ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_performance1 = _window1.performance) === null || _window_performance1 === void 0 ? void 0 : (_window_performance_navigation = _window_performance1.navigation) === null || _window_performance_navigation === void 0 ? void 0 : _window_performance_navigation.type) === 2;
    }
};
export const initBackForward = async (func)=>{
    window.addEventListener('pageshow', (e)=>{
        if (e.persisted) return func();
    });
};
export const initChangeWindow = (func)=>{
    let is_focus_out = false;
    window.addEventListener('focus', ()=>{
        if (!is_focus_out) return;
        is_focus_out = false;
        return func();
    });
    window.addEventListener('blur', ()=>{
        is_focus_out = true;
    });
};
